(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sirene-ingredients"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sirene-ingredients')) {
 customElements.define('sirene-ingredients',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.track=this.querySelector('.srn-ingredients__track');this.cards=[...this.querySelectorAll('.srn-ingredients__card')];
   this.dots=[...this.querySelectorAll('.srn-ingredients__dot')];this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
   this.go=(i)=>{const c=this.cards[Math.max(0,Math.min(i,this.cards.length-1))];if(c)this.track.scrollTo({left:c.offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;const x=this.track.scrollLeft;this.index=this.cards.reduce((best,c,i)=>Math.abs(c.offsetLeft-this.cards[0].offsetLeft-x)<Math.abs(this.cards[best].offsetLeft-this.cards[0].offsetLeft-x)?i:best,0);if(max>1&&x>=max-2)this.index=this.cards.length-1;this.prev.disabled=x<2;this.next.disabled=x>=max-2;this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));};
   this.step=dir=>this.track.scrollBy({left:dir*(this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.prev.onclick=()=>this.step(-1);this.next.onclick=()=>this.step(1);this.dots.forEach((d,i)=>d.onclick=()=>this.go(i));
   this.track.onkeydown=e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}};
   this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
   this.onSelect=e=>{const i=this.cards.findIndex(c=>c.contains(e.target));if(i>=0)this.go(i);};this.addEventListener('shopify:block:select',this.onSelect);
  }
  disconnectedCallback(){this.observer?.disconnect();this.track?.removeEventListener('scroll',this.update);this.removeEventListener('shopify:block:select',this.onSelect);this.ready=false;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sirene-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-review]')],grid=root.querySelector('.sr-grid'),more=root.querySelector('.sr-more'),dialog=root.querySelector('dialog');
  let limit=Number(root.dataset.initial)||12,frame;
  const layout=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{grid.classList.add('sr-masonry');const gap=parseFloat(getComputedStyle(grid).rowGap);cards.forEach(card=>{if(!card.hidden)card.style.gridRowEnd=`span ${Math.ceil((card.firstElementChild.getBoundingClientRect().height+gap)/(1+gap))}`;});});};
  const update=()=>{cards.forEach((card,index)=>{card.hidden=index>=limit;});more.hidden=limit>=cards.length;layout();};
  more.addEventListener('click',()=>{const previous=cards.filter(c=>!c.hidden);limit+=Number(root.dataset.initial)||12;update();const first=cards.find(c=>!c.hidden&&!previous.includes(c));if(first)first.focus({preventScroll:true});});
  const observer=new ResizeObserver(layout);cards.forEach(card=>observer.observe(card.firstElementChild));
  root.querySelectorAll('details').forEach(el=>el.addEventListener('toggle',layout));
  root.querySelectorAll('[data-photo-link]').forEach(link=>link.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();dialog.querySelector('img').src=link.href;dialog.querySelector('img').alt=link.querySelector('img').alt;dialog.showModal();}));
  root.querySelector('.sr-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  root.addEventListener('shopify:block:select',e=>{limit=cards.length;update();e.target.scrollIntoView({block:'center'});});
  const unload=e=>{if(e.target.contains(root)){observer.disconnect();cancelAnimationFrame(frame);document.removeEventListener('shopify:section:unload',unload);}};document.addEventListener('shopify:section:unload',unload);
  update();
 };
 document.querySelectorAll('[data-sirene-reviews]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sirene-reviews]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sirene-tracking"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('sirene-tracking')) {
    let trackerLoader;
    function loadTracker() {
      if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') return Promise.resolve();
      if (trackerLoader) return trackerLoader;
      trackerLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = setTimeout(() => fail(), 15000);
        const fail = () => {
          clearTimeout(timeout);
          script.remove();
          trackerLoader = undefined;
          reject(new Error('Tracker unavailable'));
        };
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.onerror = fail;
        script.onload = () => {
          if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') { fail(); return; }
          clearTimeout(timeout);
          resolve();
        };
        document.head.appendChild(script);
      });
      return trackerLoader;
    }
    customElements.define('sirene-tracking', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="tracking"]');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');
        this.result = this.querySelector('.sr-track__result');
        this.embed = this.querySelector('.sr-track__embed');
        this.live = this.querySelector('.sr-track__live');
        this.labels = Object.fromEntries([...this.querySelectorAll('[data-key]')].map(el => [el.dataset.key, el.textContent]));
        this.fallback = this.querySelector('.sr-track__fallback');
        this.parcels = this.querySelector('.sr-track__parcels');
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          if (this.busy) return;
          this.parcels.hidden = true;
          if (this.form.querySelector('[name="method"]:checked')?.value === 'order') this.lookupOrder();
          else this.track();
        });
        this.form.querySelectorAll('[name="method"]').forEach(radio => radio.addEventListener('change', () => {
          const orderMode = radio.value === 'order';
          this.querySelector('[data-tracking-fields]').hidden = orderMode;
          this.querySelector('[data-order-fields]').hidden = !orderMode;
          this.input.disabled = orderMode;
          this.querySelectorAll('[data-order-fields] input').forEach(input => {input.disabled = !orderMode;});
          this.embed.hidden = true; this.live.hidden = true; this.fallback.hidden = true; this.parcels.hidden = true; this.status.textContent = '';
        }));
        const params = new URLSearchParams(location.search);
        const hash = new URLSearchParams(location.hash.slice(1));
        const number = params.get('tracking') || params.get('nums') || hash.get('nums');
        if (number && /^[A-Za-z0-9][A-Za-z0-9 -]{3,49}$/.test(number)) {
          this.input.value = number;
          this.track();
        }
      }
      renderTracking(data) {
        const stamp = value => typeof value === 'string' && !Number.isNaN(Date.parse(value));
        const format = value => new Date(value).toLocaleString(document.documentElement.lang || 'en', {day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',timeZoneName:'short'});
        this.live.querySelector('[data-live-status]').textContent = this.labels['status_' + data.status] || this.labels.status_unknown;
        this.live.querySelector('[data-live-carrier]').textContent = [data.number, typeof data.carrier === 'string' ? data.carrier : ''].filter(Boolean).join(' · ');
        const milestones = this.live.querySelector('.sr-track__milestones');
        milestones.replaceChildren();
        const stages = ['InfoReceived','PickedUp','Departure','Arrival','OutForDelivery','Delivered'];
        for (const extra of ['AvailableForPickup','Returning','Returned']) {
          if (data.milestones.some(m => m && m.stage === extra && stamp(m.time))) stages.push(extra);
        }
        for (const stage of stages) {
          const milestone = data.milestones.find(m => m && m.stage === stage && stamp(m.time));
          const li = document.createElement('li');
          const title = document.createElement('strong'); title.textContent = this.labels['live_' + stage]; li.append(title);
          if (milestone) {
            li.className = 'is-confirmed';
            const time = document.createElement('time'); time.dateTime = milestone.time; time.textContent = this.dataset.confirmed + ' · ' + format(milestone.time); li.append(time);
          } else {
            const note = document.createElement('span'); note.textContent = this.dataset.unconfirmed; li.append(note);
          }
          milestones.append(li);
        }
        const history = this.live.querySelector('[data-events]'); history.replaceChildren();
        const events = data.events.filter(e => e && typeof e.description === 'string').slice(0,200).sort((a,b) => (Date.parse(b.time)||0)-(Date.parse(a.time)||0));
        for (const event of events) {
          const li = document.createElement('li');
          const time = document.createElement('time');
          if (stamp(event.time)) {time.dateTime = event.time; time.textContent = format(event.time);}
          const content = document.createElement('div'); content.textContent = event.description;
          if (typeof event.location === 'string' && event.location) {const place = document.createElement('small'); place.textContent = event.location; content.append(place);}
          li.append(time, content); history.append(li);
        }
        if (!events.length) {const li = document.createElement('li'); li.textContent = this.dataset.noEvents; history.append(li);}
        this.live.hidden = false;
      }
      setBusy(value) {
        this.busy = value;
        this.button.disabled = value;
        this.querySelectorAll('[name="method"], [data-parcel-buttons] button').forEach(button => {button.disabled = value;});
      }
      async lookupOrder() {
        if (this.busy || !this.form.reportValidity()) return;
        this.setBusy(true);
        this.embed.hidden = true; this.live.hidden = true; this.fallback.hidden = true;
        this.result.replaceChildren(); this.parcels.hidden = true;
        this.status.textContent = this.dataset.loading;
        let firstNumber;
        try {
          const endpoint = new URL(this.dataset.orderEndpoint, location.origin);
          if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/')) throw new Error('Invalid proxy');
          const response = await fetch(endpoint, {
            method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({orderNumber:this.form.elements.order.value.trim(),email:this.form.elements.email.value.trim()}),
            signal:AbortSignal.timeout(15000), cache:'no-store'
          });
          if (!response.ok) {
            this.status.textContent = response.status === 404 ? this.dataset.lookupError : this.dataset.lookupUnavailable;
            return;
          }
          const data = await response.json();
          if (!this.isConnected) return;
          if (data.state === 'unfulfilled' && Array.isArray(data.shipments) && data.shipments.length === 0) {
            this.status.textContent = this.dataset.lookupPending; return;
          }
          if (!Array.isArray(data.shipments)) throw new Error('Invalid order response');
          const numbers = [...new Set(data.shipments.map(s => s && s.number).filter(n => typeof n === 'string' && /^[A-Za-z0-9][A-Za-z0-9 -]{3,49}$/.test(n)).map(n => n.toUpperCase()))];
          if (!numbers.length) {this.status.textContent = this.dataset.lookupError; return;}
          const buttons = this.querySelector('[data-parcel-buttons]'); buttons.replaceChildren();
          numbers.forEach(number => {
            const button = document.createElement('button'); button.type = 'button'; button.textContent = number;
            button.addEventListener('click', () => this.track(number)); buttons.append(button);
          });
          this.parcels.hidden = numbers.length < 2;
          firstNumber = numbers[0];
          this.form.elements.email.value = '';
        } catch (error) {
          this.status.textContent = this.dataset.lookupUnavailable;
        } finally {
          this.setBusy(false);
        }
        if (firstNumber) await this.track(firstNumber);
      }
      async track(selectedNumber) {
        if (this.busy || (!selectedNumber && !this.form.reportValidity())) return;
        const number = (selectedNumber || this.input.value).trim().toUpperCase();
        if (!/^[A-Z0-9][A-Z0-9 -]{3,49}$/.test(number)) return;
        this.setBusy(true);
        this.querySelectorAll('[data-parcel-buttons] button').forEach(button => button.setAttribute('aria-pressed', String(button.textContent === number)));
        this.status.textContent = this.dataset.loading;
        this.embed.hidden = true;
        this.live.hidden = true;
        this.result.replaceChildren();
        this.fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
        this.fallback.hidden = false;
        try {
          if (this.dataset.endpoint) {
            try {
              const endpoint = new URL(this.dataset.endpoint, location.origin);
              if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/')) throw new Error('Invalid proxy');
              endpoint.searchParams.set('number', number);
              const response = await fetch(endpoint, {headers:{Accept:'application/json'}, signal:AbortSignal.timeout(15000)});
              if (!response.ok) throw new Error('Tracking unavailable');
              const data = await response.json();
              if (data.number !== number || typeof data.status !== 'string' || !Array.isArray(data.events) || !Array.isArray(data.milestones)) throw new Error('Invalid tracking response');
              if (!this.isConnected) return;
              this.renderTracking(data);
              this.status.textContent = '';
              return;
            } catch (error) {
              this.status.textContent = this.dataset.apiFallback;
            }
          }
          await loadTracker();
          if (!this.isConnected) return;
          this.embed.hidden = false;
          window.YQV5.trackSingle({YQ_ContainerId:this.result.id,YQ_Height:560,YQ_Fc:'0',YQ_Lang:'en',YQ_Num:number});
          this.status.textContent = this.dataset.ready;
        } catch (error) {
          this.embed.hidden = true;
        this.live.hidden = true;
          this.status.textContent = this.dataset.error;
        } finally {
          this.setBusy(false);
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
